import axios from 'axios';

const fetchPricing = async (url) => {
    return await axios.post('https://apt.webeezix.in/api/public/website/getpackagesp')
}

export { fetchPricing };